import { Component, OnInit } from '@angular/core';





@Component({
  selector: 'app-crypto',
  templateUrl: './crypto.component.html',
  styleUrls: ['./crypto.component.css']
})
export class CryptoComponent implements OnInit {


  public pubKey = 'pubKeysd';
  public name:String = 'Ausgabe';


  constructor() { }


  enc() {
    
  }

  ngOnInit() { this.logIt(`OnInit`); }

  logIt(msg: string) {
    console.log(msg);
  }

}



// WEBPACK FOOTER //
// ./src/app/crypto/crypto.component.ts